import { useCompletionHistoryCustomFilters, useReduxState } from 'hooks';
import { useRouter } from 'next/router';
import { FlexContainer, Search } from 'components/common';
import { DateRangeSelector } from 'components/common/charts';
import { Filters, FiltersActive } from 'components/common/filter';

interface Props {
  setLoading: React.Dispatch<React.SetStateAction<any>>;
}

const CompletionHistorySubHeader = ({ setLoading }: Props) => {
  const { messages } = useReduxState();

  const router = useRouter();

  const handleDateRangeChange = ({ fromDate, toDate }) => {
    setLoading(true);
    if (fromDate && toDate) {
      router.replace({ query: { ...router.query, fromDate, toDate } });
    } else {
      const queryParams = router.query || {};
      delete queryParams.fromDate;
      delete queryParams.toDate;

      router.replace({ query: queryParams });
    }
  };

  const handleSearch = ({ search }: { search: string }) => {
    setLoading(true);
    if (search) {
      router.replace({
        query: { ...router.query, searchTitle: search, page: 1 }
      });
    } else {
      const queryParams = router.query || {};
      delete queryParams.searchTitle;

      queryParams.page = '1';
      router.replace({ query: queryParams });
    }
  };

  return (
    <>
      <FlexContainer
        style={{
          gap: '10px 20px',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <div style={{ display: 'flex', gap: 10 }}>
          <div style={{ width: 220 }}>
            <Search
              onSearch={handleSearch}
              placeholder={messages.commonTitle}
              size="header"
            />
          </div>

          <Filters
            allowMultiple={{
              accountAccess: true,
              accountIdentifier: true,
              accountLogin: true,
              accountType: true,
              groups: true,
              supervisors: true,
              userAttributes: true
            }}
            customFilters={useCompletionHistoryCustomFilters()}
            filterId="analytics-users"
            filters={{
              accountAccess: true,
              accountIdentifier: true,
              accountLogin: true,
              accountType: true,
              groups: true,
              supervisors: true,
              userAttributes: true
            }}
          />
        </div>

        <DateRangeSelector
          size="header"
          includeAllTimeOption={true}
          updateData={handleDateRangeChange}
        />
      </FlexContainer>

      <FiltersActive filterId="analytics-users" />
    </>
  );
};

export default CompletionHistorySubHeader;
